module.exports = __webpack_public_path__ + "static/img/rrrr_03.1b3dc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_03.png
// module id = DxFw
// module chunks = 1